import {css, useTheme} from '@mui/material';
import {GetStylesFunction, LoadingSpinner} from '@wallaby-ui/core';
import {documentContainer, HaidiSchema} from '@wallaby-ui/document';
import classNames from 'classnames';
import * as React from 'react';

import {NotFoundComponentBox} from '../NotFoundComponentBox';

type Document = HaidiSchema.components['schemas']['DocumentViewDto'];
interface OwnProps {
  isLoading: boolean;
  isError: boolean;
  documentData: Document;
  /** Document-version id from the URL — threaded down to the placeholder table
      component since the MERIE DocumentViewDto does not carry it. */
  documentVersionId?: string;
  storageIdPrefix: string;
}

type Props = OwnProps;

export const HospitalizationDocumentLayout: React.FC<Props> = (props) => {
  const {isError, isLoading, documentData, documentVersionId, storageIdPrefix} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div css={styles.wrapper}>
      <div
        css={styles.loadingWrapper}
        className={classNames('dlLoadingSpinnerContainer', 'dlFlexBoxContainerInContainer', {
          dlLoadingSpinnerParent: isLoading,
        })}
      >
        <LoadingSpinner isVisible={isLoading} />
        {isError ? (
          <NotFoundComponentBox hideHelmet />
        ) : (
          <documentContainer.HospitalizationDocument
            documentData={documentData}
            documentVersionId={documentVersionId}
            storageIdPrefix={storageIdPrefix}
            maximized={false}
            setMinimizedMaximized={() => {
              // old layout not supported
            }}
          />
        )}
      </div>
    </div>
  );
};

HospitalizationDocumentLayout.displayName = 'HospitalizationDocumentLayout';

const getStyles: GetStylesFunction = (options) => ({
  loadingWrapper: css`
    align-self: stretch;
  `,
  wrapper: css`
    background-color: #ffffff;
    gap: ${options?.theme?.spacing(3)};
    display: flex;
    flex-direction: column;
    padding: ${options?.theme?.spacing(4)};
    align-items: flex-start;
    align-self: stretch;
    border-radius: ${options?.theme?.spacing(6)};
    height: 100%;
    overflow: hidden;
  `,
});
